import { IParceiroTheme, Parceiros } from '@/interfaces'
import { Atta } from '@/interfaces/IATTA'
import { AttaHttpClientFactory } from './http/AttaHttpClientFactory'
import { IUsuarioIsolve } from '../interfaces/IUsuarioIsolve'
import { IApiResponse } from '../interfaces/IApiResponse'
import { IPropostaAtualizarRequest } from '@/interfaces/IPropostaAtualizarRequest'
import { SolicitacaoTopico } from '@/constants'

const http = AttaHttpClientFactory.create(import.meta.env.VUE_APP_API_ATTA_SERVICES)

export class AttaService {
	static async getCategoria() {
		const { data } = await http.get('/parceiros/categorias')
		return data
	}

	static async getResponsavel(franquiaId: number) {
		const { data } = await http.get(`/franquias/${franquiaId}/usuario-lista`)
		return data
	}

	static async GetAgentIdList() {
		const { data } = await http.get('/parceiros/agent-id/list')
		return data
	}

	static async getUsuarioById(userId: number) {
		var response = await http.get<IApiResponse<IUsuarioIsolve>>(`/atta/usuarios/${userId}`)
		return response.data
	}

	/**
	 * Value Confirmation
	 * @param propostaId
	 * @returns
	 */
	static async postValuesConfirmation(propostaId: number, confValores: any) {
		const { data } = await http.post(`/propostas/${propostaId}/confirmacao-valores`, confValores)
		return data
	}

	/**
	 * Endpoint de geração de link.
	 * @param refId
	 * @param topico
	 * @returns
	 */
	static async getExternalLinkBySolicitacaoRefId(refId: number, topico: SolicitacaoTopico) {
		var { data } = await http.get(`/atta/${refId}/id/${topico}/topico`)
		return data
	}
}
